import VeeValidate from 'vee-validate'

/**
 * SmartShopから移管されたユーザーのための独自のメールアドレスの検査.
 * 導入された経緯: https://github.com/Everforth/growthpalette-front/issues/2128
 *
 * ただし、これらのメールアドレスについて実際にメールが届かないためエラーが度々発生している.
 * ユーザーに適切なメールアドレスに更新してもらうことがサービスとしても望ましいため以下のように2種類のバリデーションを使い分ける.
 *
 * (1) 独自の検査
 * SmartShopで利用されていたバリデーションを採用する.
 * 既存のユーザーがログインできなくなることを避けるためにのみ存在し、原則としてログイン時にのみ適用する.
 *
 * (2) 通常の検査
 * VeeValidateのデフォルトのemailルールを採用する.
 * 新規会員登録、ユーザー情報更新、新作・再入荷リクエスト登録など、ログイン以外の全ての箇所で適用する.
 *
 * 方針転換となったissue: https://github.com/Everforth/growthpalette-front/issues/7837
 */
VeeValidate.Validator.extend('email-compatible-with-old-system', {
  /**
   * :pensive: https://github.com/my-color/front/issues/2128
   *
   * ピリオド連続等、RFC違反のメールアドレスも利用できてしまうが、
   * SmartShopがそうしたメールアドレスが許容されてしまう正規表現を使っており、
   * 実際にRFC違反のメールアドレスも登録できてしまっている.
   *
   * 既存ユーザー救済のため、↓の正規表現を使い、RFC違反については見て見ぬ振り.
   */
  validate: async (value: any) => {
    return validateEmailForOldSystem(value)
  },
})

export const validateEmailForOldSystem = (input: string): boolean => [
  /**
   * 経緯
   *
   * (1) もともとはSmartShopで利用されていた正規表現を採用した
   * https://github.com/Everforth/growthpalette-front/issues/2128
   *
   * (2) 後にRFCでローカル部に許可されている記号を追加した
   * https://github.com/Everforth/growthpalette-front/issues/2146
   * https://tools.ietf.org/html/rfc5322#section-3.2.3
   *
   * (3) さらにTLD部分の制限を緩めた
   * https://github.com/Everforth/growthpalette-front/issues/8943#issuecomment-4248648142
   */
  /^[_a-zA-Z0-9-.()!#$%&'*+/=?^_`{|}~]+@[a-zA-Z0-9-.]+(\.[a-zA-Z0-9-]+)$/,
].every(rule => rule.test(input))
